<template>
  <div class="bg-white pt-3 border rounded shadow-sm p-4">
    <h3 class="text-l font-bold mb-4">
      Administrator roles
    </h3>
    <table class="table-auto w-full">
      <thead>
      <tr class="text-left border-b">
        <th class="px-4 py-2 ">#</th>
        <th class="px-4 py-2 ">Name</th>
        <th class="px-4 py-2">Description</th>
        <th class="px-4 py-2"></th>
      </tr>
      </thead>
      <tbody>
      <tr class="border-b hover:bg-gray-200" v-for="(role, index) in roles" :key="role.id">
        <td class="px-4 py-2 hover:text-teal-500"> {{ index + 1 }}</td>
        <td class="px-4 py-2 hover:text-teal-500">
          <router-link :to="{name: 'access_control', params: { path: 'role', id: role.id}}">
            {{ role.name }}
          </router-link>
        </td>
        <td class="px-4 py-2">{{ role.description }}</td>
        <td class="px-4 py-2">
          <button @click="removeRole(role)" v-if="$store.getters.can('delete_roles')"
                  class="bg-transparent hover:bg-red-500 text-red-500 hover:text-white py-1 px-2 border border-red-500 hover:border-transparent rounded mr-2">
            Remove
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";

export default {
  name: "RolesComponent",
  props: {
    orgId: String
  },
  data() {
    return {
      searchString: '',
      recordsPerPage: 10,
      currentPage: 1,
      loading: true,
      roles: [],
      errors: []
    }
  },
  mounted() {
    this.getRoles()
  },
  watch: {
    errors: function (errors) {
      this.$root.$emit("alert_error", errors);
    }
  },
  computed: {
    offset: function () {
      return (this.currentPage - 1) * this.recordsPerPage;
    }
  },
  methods: {
    removeRole(role) {
      if (!this.$store.getters.can('delete_roles')) {
        this.$root.$emit("alert_error", ['Not allowed to delete administrator roles']);
        return;
      }
      let params = 'id: "' + role.id + '"';
      GraphQl.sendRequest('mutation{removeRole(' + params + ') {code message}}')
          .then((response) => {
            this.$root.$emit("alert_info", [response.removeRole.message]);
            this.getRoles();
          })
    },
    getRoles() {
      this.loading = true
      let params = 'limit: ' + this.recordsPerPage + ', offset: ' + this.offset + ', order: "created_at desc", search: "' + this.searchString + '"';
      GraphQl.sendRequest('{roles(' + params + ') {id name description created_at}}')
          .then(response => {
            this.roles = response.roles;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>

</style>